import { Component } from '@angular/core';

/**
 * @deprecated This component is deprecated and will be removed in the next major version.
 */
@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.css'
})
export class AppHeaderComponent {
}
